import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createBlock(_component_BaseButton, { class: "content-btn success xs b-4 uc" }, {
    left: _withCtx(() => [
      _createElementVNode("img", {
        src: require('../../assets/icons/sell.svg')
      }, null, 8, _hoisted_1)
    ]),
    default: _withCtx(() => [
      _createTextVNode(" " + _toDisplayString(_ctx.t('InventoryItemOverlay.sell')), 1)
    ]),
    _: 1
  }))
}